export default __webpack_public_path__ + "static/yourJob-0ed3d4d205f5990c8f42f433c2a6bdaa.webp";